import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import useConfig from '../../../config';
import { callWith } from '../../../util';

const demoToken = 'demoToken';

const Recaptcha = React.memo(props => {
	const config = useConfig();

	const allowAutomation = config.allowAutomation;
	const usingAutomation = config.automation;

	const handleChange = token => props.onChange && props.onChange(token);

	if(allowAutomation && usingAutomation) {
		return <a onClick={callWith(handleChange, demoToken)} className="recaptcha">[RECAPTCHA]</a>; //eslint-disable-line jsx-a11y/anchor-is-valid
	}

	const recaptchaConfig = config.recaptcha;
	return recaptchaConfig ? (
		<ReCAPTCHA
			{...recaptchaConfig}
			{...props}
			onChange={handleChange}
		/>
	) : null;
});

export default Recaptcha;